// Traducción de los errores de entregar la tarjeta física (paso 09) a algo que el vendedor pueda
// ACCIONAR frente al cliente.
//
// 🔴 Quedarse sin tarjetas NO es una falla del sistema: es un hecho de la tienda, y el vendedor
// tiene que leerlo como tal para ir por más plásticos en vez de reintentar en vano.
//
// ⚠️ Hoy `INSUFFICIENT_CARD_STOCK` no llega: `RetailCardsApiAdapter` del wizard atrapa todo lo que
// devuelve retail-cards y lo re-lanza como `EXTERNAL_INTEGRATION_ERROR` (502). Por eso ese código
// también nombra el inventario como causa probable — es la única pista que llega al mostrador.
import { RequestTimeoutError } from '@/api/client';
import { ApiError } from '@/api/errors';

const MESSAGE_BY_CODE: Record<string, string> = {
    // El saldo de la tienda no alcanza. Lo detecta la condición `available >= :quantity` del silo.
    INSUFFICIENT_CARD_STOCK:
        'Esta tienda se quedó sin tarjetas. Pide más plásticos antes de seguir entregando.',
    // La tienda nunca recibió un lote: no hay inventario del cual descontar.
    CARD_STOCK_NOT_FOUND:
        'Esta tienda no tiene inventario de tarjetas registrado. Avisa a tu gerente.',
    // El wizard aplasta acá el conflicto de saldo y la caída del lambda de tarjetas. No promete que
    // reintentar sirva: si la causa es saldo cero, el reintento no puede funcionar nunca.
    EXTERNAL_INTEGRATION_ERROR:
        'No se pudo registrar la entrega de la tarjeta. Revisa el inventario de la tienda: si no quedan tarjetas, pide más plásticos antes de reintentar.',
    INVALID_SESSION_STATE: 'Esta venta ya no está activa. Vuelve al portal e inicia una nueva.',
    SESSION_NOT_FOUND: 'Esta venta ya no existe. Vuelve al portal e inicia una nueva.',
    PERMISSION_DENIED: 'No tienes permiso para entregar tarjetas en esta tienda.',
};

const FALLBACK =
    'No se pudo registrar la entrega de la tarjeta. Vuelve a intentar en unos segundos.';

/**
 * Mensaje accionable para el vendedor ante un fallo de la entrega.
 * Un código que este front no conoce cae a su `msg` crudo: feo, pero verdadero.
 */
export function cardDeliveryErrorMessage(error: unknown): string {
    if (error instanceof RequestTimeoutError) {
        return 'La entrega tardó demasiado. Vuelve a intentar: si ya se registró, no se descuenta dos veces.';
    }
    if (!(error instanceof ApiError)) return FALLBACK;

    const known = MESSAGE_BY_CODE[error.code] as string | undefined;
    if (known !== undefined) return known;

    if (error.httpStatus === 401 || error.httpStatus === 403) {
        return 'Tu sesión perdió permisos sobre esta tienda. Vuelve a iniciar sesión.';
    }
    return error.msg !== '' ? error.msg : FALLBACK;
}
